(function () {
  var THRESHOLD = 40;
  var lastSolid = null;

  function isHome() {
    return !!(document.body && document.body.classList.contains("index"));
  }

  function isPhone() {
    return window.matchMedia && window.matchMedia("(max-width: 1023.98px)").matches;
  }

  function scrollY() {
    var y = 0;
    if (window.lenis && typeof window.lenis.scroll === "number") y = window.lenis.scroll;
    else if (document.documentElement && document.documentElement.lenis && typeof document.documentElement.lenis.scroll === "number") y = document.documentElement.lenis.scroll;
    else y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (typeof y !== "number" || isNaN(y) || y < 0) return 0;
    return y;
  }

  function applySolid(solid) {
    document.documentElement.classList.toggle("grok-header-solid", solid);
    var section = document.querySelector(".header-section");
    if (section) section.classList.toggle("grok-header-solid", solid);
  }

  function sync() {
    // Phone: always solid so the hamburger stays dark and tappable.
    // Inner pages: always solid (light backgrounds).
    // Desktop home: clear at top, solid after scroll.
    var solid = isPhone() || !isHome() || scrollY() > THRESHOLD;
    if (solid === lastSolid) return;
    lastSolid = solid;
    applySolid(solid);
  }

  applySolid(true);
  lastSolid = true;
  sync();
  window.addEventListener("scroll", sync, { passive: true });
  document.addEventListener("scroll", sync, { passive: true, capture: true });
  window.addEventListener("resize", function () { lastSolid = null; sync(); }, { passive: true });
  window.addEventListener("wheel", function () { requestAnimationFrame(sync); }, { passive: true });
  window.addEventListener("touchmove", function () { requestAnimationFrame(sync); }, { passive: true });
  window.addEventListener("load", function () {
    lastSolid = null;
    sync();
  });

  function bindLenis() {
    var l = window.lenis || (document.documentElement && document.documentElement.lenis);
    if (l && typeof l.on === "function") {
      l.on("scroll", sync);
      return true;
    }
    return false;
  }

  if (!bindLenis()) {
    var n = 0;
    var t = setInterval(function () {
      n += 1;
      if (bindLenis() || n > 40) clearInterval(t);
      lastSolid = null;
      sync();
    }, 250);
  }
})();
